import { action, createRequestTypes } from "../../actions";

export const LOAD_CLINICS = createRequestTypes("LOAD_CLINICS");
export const SELECT_CLINIC = "SELECT_CLINIC";

export const loadClinics = {
  request: () => action(LOAD_CLINICS.REQUEST, { }),
  success: response => action(LOAD_CLINICS.SUCCESS, { response }),
  failure: error => action(LOAD_CLINICS.FAILURE, { error }),
};

export const selectClinic = (clinic) =>
  action(SELECT_CLINIC, { clinic });
